import {Component, Input, OnInit} from '@angular/core';
import {Listing} from '../../../classes/listing';
import {HasSubscriptions} from '../../../components/has-subscriptions';

@Component({
  selector: 'app-property-details',
  templateUrl: './property-details.component.html',
  styleUrls: ['./property-details.component.scss']
})
export class PropertyDetailsComponent extends HasSubscriptions implements OnInit {
  @Input() listing: Listing = new Listing();

  // We need to differentiate this since on all pages except the listing details page, the luxury component shows the same property details styling as residential and commercial
  @Input() isListingDetails: boolean;
  ngOnInit() {}
}
